import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Accordion } from "@/components/@common/Accordion";
import { usePreviewDialogStore } from "@/components/Search/PreviewDialogProvider";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { cn } from "@/lib/utils";
import useWindowDimensions from "@/lib/web-ui/useWindowDimensions";
import { BRAND_HOME_PAGE, PRODUCTS_DETAIL_PAGE } from "@/settings/constant";
import { Button, Typography } from "@bookips/sds";
import dayjs from "dayjs";
import { useRouter } from "next/router";
import { useState } from "react";
import BrandRankingDropdownItem from "./BrandRankingAccordionItem";
import HomeSectionLayout from "./HomeSectionLayout";
/** 랭킹 카테고리 라벨 매핑 */ const RANKING_CATEGORY_LABELS = {
    popular: "인기순",
    review: "리뷰순",
    subscriber: "구독자순"
};
/**
 * 브랜드 랭킹 섹션
 * - 카테고리 탭으로 필터링
 * - 아코디언으로 브랜드별 상품 표시
 */ const Ranking = (param)=>{
    let { data , className  } = param;
    const router = useRouter();
    const { header , title , categories , aggregationDays , brandsByCategory , useCtaButton , ctaButtonName , ctaButtonLink  } = data;
    const { openPreviewDialog  } = usePreviewDialogStore();
    const { isMobile  } = useWindowDimensions();
    // 첫 번째 아코디언 열린 상태로 시작
    const [openValue, setOpenValue] = useState("rank-1");
    var _categories_;
    // 카테고리 탭 상태 (categories 배열의 첫 번째가 기본값)
    const [activeCategory, setActiveCategory] = useState((_categories_ = categories[0]) !== null && _categories_ !== void 0 ? _categories_ : "");
    var _brandsByCategory_activeCategory;
    // 현재 선택된 카테고리의 브랜드 목록
    const currentBrands = (_brandsByCategory_activeCategory = brandsByCategory[activeCategory]) !== null && _brandsByCategory_activeCategory !== void 0 ? _brandsByCategory_activeCategory : [];
    // 집계 기간 계산 (오늘 기준 aggregationDays일 전 ~ 오늘)
    const today = dayjs();
    const startDate = today.subtract(aggregationDays, "day");
    var _RANKING_CATEGORY_LABELS_category;
    return /*#__PURE__*/ _jsxs(HomeSectionLayout, {
        title: title,
        header: header,
        isUseButton: useCtaButton,
        buttonText: ctaButtonName,
        buttonUrl: ctaButtonLink,
        onCtaClick: ()=>{
            // MX-381: 전체보기 버튼 클릭 트래킹
            mixpanelEvent("[Home] Ranking Section Clicked", {
                "Section Title": title,
                Type: "전체보기 버튼",
                "Button Name": ctaButtonName,
                "Button URL": ctaButtonLink
            });
        },
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center justify-between max-lg:px-8 max-sm:flex-col max-sm:items-start max-sm:gap-1.5 max-sm:px-5",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-center gap-2",
                        children: categories.map((category)=>/*#__PURE__*/ _jsx(Button, {
                                size: isMobile ? "sm" : "md",
                                variant: "stroke",
                                color: "secondary",
                                className: cn("text-primary", activeCategory === category ? "bg-gray-700 text-white outline-none" : "text-primary bg-white hover:bg-gray-50"),
                                onClick: ()=>{
                                    var _RANKING_CATEGORY_LABELS_category;
                                    // MX-381: 랭킹 로직 탭 클릭 트래킹
                                    mixpanelEvent("[Home] Ranking Section Clicked", {
                                        "Section Title": title,
                                        Type: "랭킹 로직 탭",
                                        "Button Name": (_RANKING_CATEGORY_LABELS_category = RANKING_CATEGORY_LABELS[category]) !== null && _RANKING_CATEGORY_LABELS_category !== void 0 ? _RANKING_CATEGORY_LABELS_category : category
                                    });
                                    setActiveCategory(category);
                                },
                                "data-state": activeCategory === category ? "active" : "inactive",
                                children: (_RANKING_CATEGORY_LABELS_category = RANKING_CATEGORY_LABELS[category]) !== null && _RANKING_CATEGORY_LABELS_category !== void 0 ? _RANKING_CATEGORY_LABELS_category : category
                            }, category))
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        variant: "body2",
                        className: "text-secondary max-sm:typo-caption",
                        children: [
                            "집계기간 ",
                            startDate.format("YYYY.MM.DD"),
                            " ~ ",
                            today.format("YYYY.MM.DD")
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Accordion.Root, {
                type: "single",
                collapsible: true,
                value: openValue,
                onValueChange: setOpenValue,
                className: "flex flex-col overflow-visible max-lg:px-8 max-sm:px-5 [&>[data-state=closed]:has(+[data-state=open])]:border-b-0",
                children: currentBrands.map((brand, index)=>/*#__PURE__*/ _jsx(BrandRankingDropdownItem, {
                        rank: index + 1,
                        ...brand,
                        handouts: brand.products,
                        onViewAllClick: ()=>{
                            router.push(BRAND_HOME_PAGE(brand.brandName));
                        },
                        onHandoutClick: (handoutId)=>{
                            router.push("".concat(PRODUCTS_DETAIL_PAGE).concat(handoutId));
                        },
                        onSampleClick: (handoutId)=>{
                            openPreviewDialog({
                                id: handoutId
                            });
                        }
                    }, brand.authorId))
            })
        ]
    });
};
export default Ranking;
